import Component from '../vendor/Component'

export default class MainProductGallery extends Component {
  constructor(elem, theme, options, ctx) {
    super(elem, theme, options, ctx)

    this._galleryElement = this._elem.querySelector('[data-main-product-gallery-el="swiper"]')
    this._shopTheLookCta = this._elem.querySelector('[data-main-product-gallery-el="badge"]')
    this._shopTheLookSnippet = document.querySelector('.shop-the-look-wrapper')
  }

  mount() {
    this.setupListeners()
    this.initCarousel()
    this.shopTheLookVisibility()
  }

  setupListeners() {
    this._shopTheLookCta.addEventListener('click', () => {
      this._shopTheLookSnippet.scrollIntoView({ behavior: 'smooth', block: 'nearest' });

      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({
        event: 'pdp_shop_the_look_cta_click',
      });
    })

    this._elem.addEventListener('click', this.handleLightboxProxy.bind(this));
  }

  initCarousel() {
    if (this._galleryElement) {
      new window.swiper(this._galleryElement, {
        spaceBetween: 5,
        slidesPerView: 1.2,
        loop: false,
        breakpoints: {
          992: {
            slidesPerView: 1,
          }
        },
        navigation: {
          nextEl: '[data-main-product-gallery-el="next"]',
          prevEl: '[data-main-product-gallery-el="prev"]',
        },
        on: {
          afterInit: (swiper) => {
            swiper.el.classList.remove('loading');
          }
        },
      });
    }
  }

  shopTheLookVisibility() {
    if (this._shopTheLookSnippet) {
      this._shopTheLookCta.classList.add('is-active')
    }
  }

  handleLightboxProxy(e) {
    const proxy = e.target.closest('[data-lightbox-proxy]');

    if (!proxy) return;

    e.preventDefault();

    const target = this._elem.querySelector(`[data-lightbox-index="0"]`);

    target.click();
  }
}
